import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocalStorage } from '@core/localstorage';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
    const localStorage = inject(LocalStorage);
    const isPickleball = localStorage.isPickleball() || window.location?.hostname?.includes('pickleball');

    const projectIds = {
        pickleball: 'pickleball-sp',
        ti: 'site-personalizado',
    };

    const baseUrl = 'https://i18n-cdn.tenisintegrado.com/project'
    const projectId = projectIds[isPickleball ? 'pickleball' : 'ti'];
    const url = `${baseUrl}/${projectId}/translations/`;

    return new TranslateHttpLoader(http, url);
}
